import React, { Component } from 'react';
import './../css/master.css';
import './../css/maintainStaff.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
var httpURL = '';
var querystring = require('querystring');
var lstCity = [];
var lstStaff = [];
var flag = true;

var staffIdCol 		= 'td:eq(0)';
var staffCol 		= 'td:eq(1)';
var staffEmailCol 	= 'td:eq(2)';
var staffPhoneCol 	= 'td:eq(3)';
var staffCityCol 	= 'td:eq(4)';

class MaintainStaff extends Component {
  constructor(props) {
    super(props);
    this.state ={
      staff:[],
		  city:[],
		  width:'97.6%',
		  loader:'none',
		  opacity:1,
    }
    this.maintainStaff = this.maintainStaff.bind(this);
 }
	 
	componentDidMount =()=> {
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.get(httpURL+'/a/mst/cty/list', {
			withCredentials:true
		}).then((response) => {
			if(response.data.SvcStatus === 'Success'){	
				this.setState({
					city: response.data.lstCity,
				});
				lstCity = this.state.city;
				this.fillCityCmb();
			}else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					return false;
				}
			}
		}).catch((e) => {
            toast.error('Service failed: '+e);
        });
		
		axiosInstance.get(httpURL+'/a/mst/stf/list', {
			withCredentials:true
		}).then((response) => {
			if(response.data.SvcStatus === 'Success'){	
				this.setState({
					staff: response.data.lstStaff,
				});
				lstStaff = this.state.staff;
				this.setStaffTable();
			}else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e) => {
            toast.error('Service failed: '+e);
        });
		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);
	}	
	
	fillCityCmb=()=>{
		$('#cityCmb').empty();
		$('#cityCmb').prepend($("<option> </option>").val(0).html('City'));
		for(var i=0; i<lstCity.length; i++){
	   		var cityId 	= lstCity[i].cityId;
	   		var city 	= lstCity[i].city;
	   		$('#cityCmb').append($("<option> </option>").val(cityId).html(city)); 
   		}   	
	}
	
	handleResize=()=>{
		var width = ($('.tableLayout1').parent().width())-18;
		this.setState({width:width})
	}
	
	validateEmail(x){
		var atpos = x.indexOf("@");
		var dotpos = x.lastIndexOf(".");
		if (atpos<1 || dotpos<atpos+2 || dotpos+2>=x.length) {
			return false;
		}else{
			return true;
		}
	}
	
	setStaffTable=()=>{
		$('#staffTableBody tr').remove();
		var table = document.getElementById('staffTable');
		var tbody = document.getElementById('staffTableBody');
		var filterName = $("#staffname").val().toLowerCase();
		var filterMail = $("#staffemail").val().toLowerCase();
		var filterPhone = $("#staffphone").val();
		var filterCity = $("#staffcity").val().toLowerCase();
		
		for(var i=0; i<lstStaff.length; i++){
			var staffId	= lstStaff[i].staffId;
			var staff 	= lstStaff[i].staff;
			var eMail		= lstStaff[i].eMail;
			var phoneNo	= lstStaff[i].phoneNo;
			var cityId	= lstStaff[i].cityId;
			var city		= lstStaff[i].city;
			
			var row = document.createElement('tr');
			row.onclick=(e)=>{
				flag = false;
				$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
				var staffId = $(e.target).closest('tr').find(staffIdCol).text();
				this.setStaffForm(staffId);
				$('#generatePassword').show();
			}
			
			if(staff.toLowerCase().indexOf(filterName) == -1)
				continue;
			if(phoneNo.toString().indexOf(filterPhone) == -1)
				continue;
			if(eMail.toLowerCase().indexOf(filterMail) == -1)
				continue;
			if(city.toLowerCase().indexOf(filterCity) == -1)
				continue;
			
			this.addTD(row, staffId, 'no-display');
			this.addTD(row, staff, '');
			this.addTD(row, eMail, '');
			this.addTD(row, phoneNo, 'text-center');
			this.addTD(row, city, '');
			
			tbody.append(row);
		}
		table.append(tbody);	
	}  
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		var text = document.createTextNode(val);
		cell.className = classname;
		cell.append(text);
		row.append(cell);
	}
	
	setStaffForm=(id)=>{
		$( "#email" ).attr( "disabled", true );
		var staffData = this.getStaffData(id);
		if(staffData != -1){
			$('#name').val(staffData.staff);
			$('#email').val(staffData.eMail);
			$('#phone').val(staffData.phoneNo);
			$('#cityCmb').val(staffData.cityId);
		}
	}
	
	getStaffData(id){
		for(var i=0; i<lstStaff.length; i++){
			if(lstStaff[i].staffId == id){
			   return lstStaff[i];
			}
		}
		return -1;
	}
	
	generatePassword=()=>{
		var staffId = $('#staffTableBody tr.selected').find('td:eq(0)').text();
		var emailId = $('#staffTableBody tr.selected').find('td:eq(2)').text();
		if(staffId == ''){
			toast.warning('Please select staff');
			return false; 
		}
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/stf/generatepassword',
			 querystring.stringify({"staffId":staffId, "emailId":emailId}), {withCredentials:true}
		).then((response)=>{
			if(response.data.SvcStatus === 'Success'){
				toast.success(response.data.SvcMsg);
			} 
			else{
			  toast.error(response.data.SvcMsg);  
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
		  toast.error('Service failed: '+e);
		});
	}

  maintainStaff =()=>{
	var staff	= {};
	var name	= $('#name').val();
	var email	= $('#email').val();
	var ph		= $('#phone').val();
	var cityId	= $('#cityCmb').find('option:selected').val();
	var city	= $('#cityCmb').find('option:selected').text();
	
	if(name == ''){
		toast.warning('Please fill staff name');
		document.getElementById("name").focus();
		return false;
	}

	if(email == ''){
		toast.warning('Please fill staff E-Mail');
		document.getElementById('email').focus();
		return false;
	}else{
		var result = this.validateEmail(email);
		if(result==false){
			toast.warning("Invalid Email");
			document.getElementById("email").focus();
			return false;
		}
	}
	
	if(ph == ''){
		toast.warning('Please fill staff phone number');
		document.getElementById("phone").focus();
		return false;
	}
	
	if(cityId == 0){
		toast.warning('Please select city');
		document.getElementById("cityCmb").focus();
		return false;
	}
	 
	staff.staffId = 0;
	staff.staff = name;
	staff.eMail = email;
	staff.phoneNo = ph;
	staff.cityId = cityId;
	staff.city = city;
	 
	if(flag === true){
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/stf/save',
			querystring.stringify({'staff':JSON.stringify(staff)}), {withCredentials:true}
    ).then((response)=>{
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				staff.staffId = response.data.staffId;
				lstStaff.push(staff);
				this.setStaffTable();
				this.highlightRow('staffTableBody', response.data.staffId);
				this.setStaffForm(response.data.staffId);
				flag = false;
				$('#generatePassword').show();
			}
			else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});	 
		}).catch((e)=>{
			toast.error('Service failed: '+e);
		});
	}
	else{
		var staffId = $('#staffTableBody tr.selected').find('td:eq(0)').text();
		if(staffId == ''){
			toast.warning('Please select row');
			document.getElementById("name").focus();
			return false;
		}

		if(email == ''){
			toast.warning('Please fill buyer E-Mail');
			document.getElementById('email').focus();
			return false;
		}else{
			var result = this.validateEmail(email);
			if(result == false){
				toast.warning("Invalid Email");
				document.getElementById("email").focus();
				return false;
			}
		}
	
		if(ph == ''){
			toast.warning('Please fill staff phone number');
			document.getElementById("phone").focus();
			return false;
		}
	
		if(city == 0){
			toast.warning('Please select city');
			document.getElementById("cityCmb").focus();
			return false;
		}
		 
		staff.staffId = staffId;
		this.setState({loader:'block', opacity:0.5}); 
		axiosInstance.post(httpURL+'/a/mst/stf/save',
			querystring.stringify({'staff':JSON.stringify(staff)}), {withCredentials:true}
		).then((response)=>{
			if(response.data.SvcStatus == 'Success'){
				toast.success(response.data.SvcMsg);
				var staffIdx = this.getIdxStaff(staffId);
				lstStaff.splice(staffIdx,1,staff);
				this.setStaffTable();
				this.highlightRow('staffTableBody', staffId);
				this.setStaffForm(staffId);
			}else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1}); 
		}).catch((e)=>{
			toast.error('Service failed: '+e);
		});
	}
  }
	
  getIdxStaff(id){
	for(var i=0; i<lstStaff.length; i++){
		if(lstStaff[i].staffId == id){
			return i;
		}
	}
	return -1;
 }
 
  clear=(e)=>{
		$("#staffAddForm")[0].reset();
		$('#email').attr('disabled', false);
		flag = true;
		$('#generatePassword').hide();
  }

  highlightRow(table, id){
	$('#'+table+' tr').each(function(){
		var staffId = $(this).find('td:eq(0)').text();
		if(staffId == id){
			$(this).addClass('selected').siblings().removeClass('selected');
		}
	});
  }  
  render() {
	httpURL = window.httpURL;  
	return(
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
            <div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-11 col-centered">
						<div className="col-sm-7 col-xs-11 padding-remove">
							<table className="tableLayout1" style={{width:this.state.width}}>
								<thead>
									<tr>
									  <th style={{width:5, display:'none'}}>Staff Id</th>
										<th style={{width:100}}>
											<input type= "text"  onChange = {this.setStaffTable} className= "form-control inp-search" id="staffname"  placeholder= "Staff Name"/>
										</th>
										<th style={{width:150}}>
											<input type= "text"  onChange = {this.setStaffTable} className= "form-control inp-search" id="staffemail" placeholder= "Email Id" />
										</th>
										<th style={{width:90}}>
											<input type= "text"  onChange = {this.setStaffTable} className= "form-control inp-search" id="staffphone" placeholder= "Phone No." />
										</th>
                    <th style={{width:90}}>
											<input type= "text"  onChange = {this.setStaffTable} className= "form-control inp-search" id="staffcity"  placeholder= "City" />
										</th>
									</tr>
								</thead>
                            </table>
							<div className="staffTableDiv col-sm-12 col-xs-11 padding-remove">
								<table id="staffTable" className="tableLayout">
									<colgroup>
										<col width='100' />
										<col width='150' />
										<col width='90' />
										<col width='90' />
									</colgroup>
									<tbody id="staffTableBody"></tbody>
								</table>
							</div>
                        </div>
						<div className="col-sm-1 col-xs-1">
							<span id="addStaff" title="Add Staff" onClick={this.clear} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
						<div className="col-sm-4 col-xs-12">
							<form id="staffAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-4">Staff Name:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-8">
										<input type="text" className="form-control" placeholder="Staff Name" id="name"/>
									</div>
								</div>
                <div className="form-group">
									<label className="control-label col-sm-4">E-Mail Id:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-8">
										<input type="text" className="form-control" placeholder="E-Mail Id" id="email"/>
									</div>
								</div>
								<div className="form-group">
									<label className="control-label col-sm-4">Phone:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-8">
										<input type="text" maxLength="10" className="form-control" placeholder="Phone" id="phone"/>
									</div>
								</div>
                <div className="form-group">
									<label className="control-label col-sm-4">City:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-8">
										<select className="form-control" id="cityCmb"></select>
									</div>
								</div>
								<div className="form-group" style={{marginTop:10}}>
									<div className="col-sm-12 text-center">
										<button type="button"  className="btn btn-warning" onClick={this.maintainStaff}>Save</button>
										<button style={{marginLeft:10, display:'none'}} id="generatePassword" type="button" className="btn btn-warning" onClick={this.generatePassword}>Generate Password</button>
									</div>
								</div>
              </form>
						</div>
					</div>
				</div>
			</div>
        </div>
    )};
}

export default MaintainStaff;